import { Component , Input,HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatMenuModule } from '@angular/material/menu';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms'; 

import { AnalysisOptionsComponent } from '../../tools/analysis-options/analysis-options.component';
import { HttpClient } from '@angular/common/http';
import { FacadeService } from '../../services/facade.service';

import {AnalysisServiceService } from './../../services/analysis-service/analysis-service.service';
import { ProyectosService } from '../../services/proyectos.service';


@Component({
  selector: 'errors',
  standalone: true,
  imports: [ 
    CommonModule,
    MatIconModule,
    CommonModule,
    MatListModule,
    MatCardModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatMenuModule,
    FormsModule,
    MatCheckboxModule,
    AnalysisOptionsComponent,
  ],
  templateUrl: './errors.component.html',
  styleUrl: './errors.component.css'
})
export class ErrorsComponent {
  checkbox: boolean = false;
  seeAllIconSrc = './assets/images/eye-icon.svg'; 
  isEditing_Sentence = false;
  englishType: string = 'british';//Variable de tipo de Ingles para cambiar la pestaña

  loaderActive: boolean;
  loaderActive2: boolean;
  loaderActiveFirstProject :boolean;

  currentEnglishType: string;

  UpdateErrors: boolean = false;

  results:boolean = false;

  verifyLoaderActive2: boolean;

  public errors={
    words:[],
    errors_sentence:0,
    errors_words:0,
    cantidad: 0
  }
  ishighlighted: boolean[] = this.errors.words.map(() => false);
  project_data: any;

  public hideEyeIconsForSafari1561 = false;

  private proyectoSub;
  constructor(
    private analysisService: AnalysisServiceService,
    private http: HttpClient,
    public fachada: FacadeService,
    public proyectoService: ProyectosService
    ) { }

  private sanitizeErrorsPayload(payload: any, previousHighlights: boolean[] = []): void {
    const rawWords = Array.isArray(payload?.words) ? payload.words : [];
    const sanitizedWords: string[] = [];
    const sanitizedHighlights: boolean[] = [];

    rawWords.forEach((word, index) => {
      if (typeof word === 'string' && word.trim().length > 0) {
        sanitizedWords.push(word);
        sanitizedHighlights.push(previousHighlights[index] ?? false);
      }
    });

    this.errors = {
      ...payload,
      words: sanitizedWords,
    };
    this.ishighlighted = sanitizedHighlights;
  }

  getTitleText(): string {
    return this.englishType === 'british' ? 'Lexis: British National Corpus' : 'Lexis: Corpus Of Contemporary <br> American English';
  }

  ngOnInit(): void {
    localStorage.setItem("actual","errors")
    this.isButtonDisabled();
    this.initSubscribe()
    this.hideEyeIconsForSafari1561 = false;
     if(sessionStorage.getItem("id_project")){
    this.initErrors()
    this.results = true;

     }
    if(sessionStorage.getItem("text_UID")){
      this.loaderActive = true;
    }
     this.analysisService.currentEnglishType.subscribe(mode => {
      if(mode === "american"){
        this.currentEnglishType = "American English";
      }
      else{
        this.currentEnglishType = "British English";
      }
      
    });
    
     this.proyectoService.loader$.subscribe(loader => {
      if(this.loaderActive2){
        this.loaderActive = false;
      }else{
        this.loaderActive = loader;
      }
    });   
        this.proyectoService.loaderAnalyzing$.subscribe(loader => {
      if(loader){
        this.loaderActive2 = true;
      }
      if(!loader){
        this.loaderActive2 = false;
      }
    }); 

         this.proyectoService.loaderCreatingProject$.subscribe(value => {
      if(value){
        this.loaderActive2 = true;
      }
      if(!value){
        this.loaderActive2 = false;
      }
    });

    this.proyectoService.verifyloaderAnalyzing$.subscribe(value => {
      if(value){
        this.verifyLoaderActive2 = true;
      }
      if(!value){
        this.verifyLoaderActive2 = false;
      }
    });

      setInterval(() => {
       let pantalla_actual = localStorage.getItem("actual")
    if (pantalla_actual == "errors" && sessionStorage.getItem("errors") !== "-" && !this.loaderActive && sessionStorage.getItem("id_project") && !this.verifyLoaderActive2){
       this.loaderActive2 = false;
          this.loaderActive = false;
          this.loaderActiveFirstProject = false;
          this.proyectoService.updateloader(false);
          this.initErrors()
      }
      }, 20 * 1000); // 30 segundos
  }

  initSubscribe() {
    if (!this.proyectoSub || this.proyectoSub.closed) {
      //Subscribimos al servicio para escuchar los datos
      this.proyectoSub = this.proyectoService.proyecto$.subscribe(({ proyecto, firstProject })=>{
         if(!firstProject){
            this.loaderActive = false;
            if(sessionStorage.getItem("text_UID")){
              if(!this.loaderActiveFirstProject){
              this.loaderActive2 = true;
            }
            }else{
              this.loaderActive2 = false;
            }
          }
          if(firstProject){
            this.loaderActive = false;
            if(sessionStorage.getItem("text_UID")){
              this.loaderActiveFirstProject = true;
            }else{
              this.loaderActiveFirstProject = false;
            }
          }
        console.log("Update de data --Reporta: Errors--")
        this.project_data = proyecto;
  
        this.seeAllActive = false;
        this.updateSeeAllStatus();
        if(sessionStorage.getItem("id_project")){
          this.initErrors();
        }
        
      });
    }
  }

  status: any;
  async initErrors(){
    let pantalla_actual = localStorage.getItem("actual")
    if (pantalla_actual == "errors"){
      // Intentar recuperar el resumen desde sessionStorage
      const memoryStorage = sessionStorage.getItem("errors");
  
      if (memoryStorage && !this.UpdateErrors) {
        if(memoryStorage !== "-"){
        try {
            // Si existe, convertirlo de JSON string a objeto y asignarlo
            const previousHighlights = [...this.ishighlighted];
            this.sanitizeErrorsPayload(JSON.parse(memoryStorage), previousHighlights);
              } catch (error) {
            console.log("Error en la petición de datos")
            console.log(error)
            sessionStorage.removeItem('errors');
          }finally{
            this.loaderActive2 = false;
            this.loaderActive = false;
            this.loaderActiveFirstProject = false;
            this.proyectoService.updateloader(false);
          }
        }
      }
      if(!memoryStorage || this.UpdateErrors){
        sessionStorage.setItem("errors", "-");
        //Tenemos que esperar unos milisegundos en lo que el servicio actualiza la info
        await new Promise(resolve => setTimeout(resolve, 10));
        try {
          let respuesta = null
          let textUID = sessionStorage.getItem('text_UID');
          if(this.checkbox){
            respuesta = await this.fachada.getErrorsOfProjectIZE(this.http,textUID,"");
          }else{
            respuesta = await this.fachada.getErrorsOfProject(this.http,textUID,"");
          }
          const previousHighlights = [...this.ishighlighted];
          this.sanitizeErrorsPayload(respuesta, previousHighlights);
          sessionStorage.setItem("errors", JSON.stringify(this.errors));
          this.status = 200
          } catch (error) {
           if (error?.status === 0) {
            console.error("Error 500: Error interno del servidor (errors)");
            sessionStorage.removeItem('errors');
            this.status = 0

          } else {
            console.log("Otro error en la petición de datos")
            console.log(error)
            sessionStorage.removeItem('errors');
          }
          this.status = error?.status;
        }finally{
          if (this.status === 0) {
            this.loaderActive2 = true;
            this.loaderActive = true;
            this.loaderActiveFirstProject = true;
            this.proyectoService.updateloader(true);
            this.UpdateErrors = true;
            setTimeout(() => {
              this.initErrors();
            }, 100);
          }else{
            this.loaderActive2 = false;
            this.loaderActive = false;
            this.loaderActiveFirstProject = false;
            this.proyectoService.updateloader(false);
            this.UpdateErrors = false;
             setTimeout(() => {
              this.initErrors();
            }, 100);
          }
          
         
        }
  
      
      }
       }
    else{
      console.log(`errors no es la pantalla actual así que bloqueamos peticiones`)
    }
    /// Función para saber si el tipo de Inglés es British o American
    this.analysisService.currentEnglishType.subscribe(type => {
      this.englishType = type;
    });
  }

  public isSafariVersion1561(): boolean {
    const ua = navigator.userAgent;
    const safariMatch = ua.match(/Version\/([\d.]+) Safari\//);
    const isSafari = ua.includes("Safari") && ua.includes("Macintosh") && !ua.includes("Chrome");

    if (safariMatch && safariMatch[1] && isSafari) {
      return safariMatch[1] === "15.6.1";
    }

    return false;
  }

  toggleIZE(){
    this.checkbox = !this.checkbox;
    this.initErrors();
  }

  seeAllActive: boolean = false;
  toggleEyeIcon(position, word) {
    // Si la palabra ya está marcada, desmarcarla
    if (this.ishighlighted[position]) {
        this.ishighlighted[position] = false;
        this.proyectoService.undoMarcadoErrors([word], "Error",this.http);
    } else {
        // Apagar todas las palabras antes de marcar la nueva
        this.ishighlighted.fill(false);

        // Marcar solo la palabra seleccionada
        this.ishighlighted[position] = true;
        this.proyectoService.realizarMarcadoErrors([word], "Error", this.http);
    }

    // Si "See All" está activo y se marca una palabra manualmente, apagarlo
    if (this.seeAllActive) {
        this.seeAllActive = false;
        this.updateSeeAllStatus();
    }

  }

  isButtonDisabled(): boolean {
    return !sessionStorage.getItem("text_UID"); 
  }

  toggleSeeAll() {
    if (this.seeAllActive) {
        // Si ya está activado, desmarcar todas las palabras
        this.ishighlighted = this.ishighlighted.map(() => false);
        this.proyectoService.undoMarcadoErrors(this.errors.words, "Error",this.http);
    } else {
        // Si está desactivado, marcar todas las palabras
        this.proyectoService.realizarMarcadoErrors(this.errors.words, "Error", this.http);
    }

    // Al activar "See All", asegurarse de que los ojos individuales estén apagados
    if (!this.seeAllActive) {
        this.ishighlighted.fill(false);
    }

    // Cambiar el estado de "See All"
    this.seeAllActive = !this.seeAllActive;
    this.updateSeeAllStatus();

  }


  updateSeeAllStatus() {
      // El estado del icono depende de "See All" sin cambiar los ojos
      this.seeAllIconSrc = this.seeAllActive ? './assets/images/yellow_icons/eye-on-icon.svg' : './assets/images/eye-icon.svg';
  }




  
  
  onKeyPress(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.saveValue_Sentence();
    }
  }
  
  editValue_Sentence() {
    this.isEditing_Sentence = true;
    document.addEventListener('click', this.handleClickOutside);
  }

  async saveValue_Sentence() {
    this.UpdateErrors = true;
    this.isEditing_Sentence = false;
    document.removeEventListener('click', this.handleClickOutside);
    let new_data = {new_data: this.errors}
    await this.fachada.UpdateErrorsMetrics(this.http, sessionStorage.getItem('text_UID'), new_data)
    sessionStorage.removeItem('score');
    this.initSubscribe()
  }

  // Función que se ejecuta cuando se hace clic en cualquier parte del documento SENTENCE
  handleClickOutside = (event: Event) => { 
    const target = event.target as HTMLElement; 
    if (!target.closest('.editable-input') && !target.closest('.edit-icon')) { 
      this.saveValue_Sentence(); 
    }
  }
}
